const community = [
  {
    title: 'Chair, Juneteenth Hackathon',
    description:
      "Serving as a chair for one of the country's most meaningful celebrations of Black excellence in tech. Focused on making the hackathon a launchpad for the next generation of Black engineers, designers, and founders.",
    linkLabel: 'Juneteenth Conference board →',
    linkUrl: 'https://juneteenthconf.com/about/board/',
  },
  {
    title: 'CS Teacher, Brooklyn Public Schools (TEALS)',
    description:
      'Teaching computer science to high schoolers through the TEALS program. Delivered lessons on generative AI and cybersecurity. Hosted career days and helped students see themselves in the industry.',
  },
  {
    title: 'Board of Directors, Seattle Pride',
    description:
      'Helped transition the Seattle Pride Parade to a virtual event during the pandemic. Supported fundraising and community engagement during a critical moment for the organization.',
  },
  {
    title: 'Volunteer, Black Girls Code & Girls Who Code',
    description:
      'Led coding workshops, hackathons, and summer camps. Developed an 8-week HTML/CSS curriculum for high school students in Toledo, Ohio.',
  },
  {
    title: 'Lab IT Technician, Center on Halsted',
    description:
      'Supported LGBTQ+ community members in Chicago with resume building, computer literacy, and the skills needed to access economic opportunity.',
  },
];

export default community;
